import React from 'react';
import PropTypes from 'prop-types';

import { MText } from '../../../../atoms/MText';

import { StyledTileProductItemCon } from './skins';

export default function TileProduct({
  isLastProduct,
  isMobile,
  product,
  theme,
  selectedProducts,
  getProductAndSelectedVariantData,
}) {
  const { id, title, titleWithVariables, variants } = product;

  const titleWithVariablesArr = titleWithVariables.split(/({{\w*}})/g);

  const {
    offerPrice,
    price,
    off,
    isDiscountDisabled,
    onProductAddonTileSelection,
  } = getProductAndSelectedVariantData(product, product.variants[0]);

  const isSelected =
    selectedProducts.findIndex(
      selProduct =>
        selProduct.id === id && selProduct.variants[0].id === variants[0].id,
    ) > -1;

  const isNothingSelected = selectedProducts.length === 0;

  return (
    <>
      <StyledTileProductItemCon
        className="mr-product-item mr-product-item--crossell mr-product-item--tile"
        onClick={() => onProductAddonTileSelection(isSelected)}
        borderRadius="0px"
        borderColor="#000000"
        backgroundColor={!isSelected ? 'transparent' : '#000000'}
        textColor={!isSelected ? theme.productAddonTileTextColor : '#ffffff'}
        fontSize={
          isMobile
            ? theme.productAddonTileMobileFontSize
            : theme.productAddonTileFontSize
        }
        mobileFontSize={theme.productAddonTileMobileFontSize}
        fontWeight={theme.productAddonTileFontWeight}
        fontStyle={theme.productAddonTileFontStyle}
        textDecoration={theme.productAddonTileTextDecoration}
        padding="10.6px"
      >
        {titleWithVariablesArr.map(subString => {
          if (!subString) {
            return null;
          }

          if (subString === '{{product_name}}') {
            return <div>{title}</div>;
          }

          if (subString === '{{product_price}}') {
            return (
              <>
                <MText
                  color={!isSelected ? theme.productPriceTextColor : '#ffffff'}
                  fontSize={theme.productPriceFontSize}
                  mobileFontSize={theme.productPriceMobileFontSize}
                  fontStyle={theme.productPriceFontStyle}
                  fontWeight={theme.productPriceFontWeight}
                  textDecoration={theme.productPriceTextDecoration}
                >
                  {offerPrice}
                </MText>
                {!isDiscountDisabled && (
                  <>
                    &nbsp;
                    <MText
                      color={
                        !isSelected
                          ? `${theme.productPriceTextColor}80`
                          : '#ffffff80'
                      }
                      fontSize={theme.productPriceFontSize}
                      mobileFontSize={theme.productPriceMobileFontSize}
                      fontStyle={theme.productPriceFontStyle}
                      textDecoration="line-through"
                    >
                      {price}
                    </MText>
                  </>
                )}
              </>
            );
          }

          if (subString === '{{discount}}') {
            if (!isDiscountDisabled) {
              return (
                <MText
                  color={theme.productDiscountTextColor}
                  fontSize={theme.productDiscountFontSize}
                  mobileFontSize={theme.productDiscountMobileFontSize}
                  fontStyle={theme.productDiscountFontStyle}
                  fontWeight={theme.productDiscountFontWeight}
                  textDecoration={theme.productDiscountTextDecoration}
                >
                  {off}
                </MText>
              );
            }
            return null;
          }

          return <div>{subString.replace(' ', String.fromCharCode(160))}</div>;
        })}
      </StyledTileProductItemCon>
      {isLastProduct && (
        <StyledTileProductItemCon
          className="mr-product-item mr-product-item--crossell mr-product-item--tile"
          onClick={() => onProductAddonTileSelection(true)} // setting hardcoded true as this will set selectedProducts === []
          borderRadius="0px"
          borderColor="#000000"
          backgroundColor={!isNothingSelected ? 'transparent' : '#000000'}
          textColor={
            !isNothingSelected ? theme.productAddonTileTextColor : '#ffffff'
          }
          fontSize={
            isMobile
              ? theme.productAddonTileMobileFontSize
              : theme.productAddonTileFontSize
          }
          mobileFontSize={theme.productAddonTileMobileFontSize}
          fontWeight={theme.productAddonTileFontWeight}
          fontStyle={theme.productAddonTileFontStyle}
          textDecoration={theme.productAddonTileTextDecoration}
          padding="10.6px"
        >
          {theme.productAddonTileDeselectText}
        </StyledTileProductItemCon>
      )}
    </>
  );
}

TileProduct.propTypes = {
  isLastProduct: PropTypes.bool,
  isMobile: PropTypes.bool,
  product: PropTypes.object,
  theme: PropTypes.object,
  selectedProducts: PropTypes.array,
  getProductAndSelectedVariantData: PropTypes.func,
};
